import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { DropdownService } from './dropdown.service';

export type DropdownItem = {
	id: number;
	text: string;
};

@Component({
	selector: 'app-dropdown-item',
	template: `
		<li
			class="border-t-2 pt-1 mt-1 border-oskarGrey cursor-pointer"
			[ngClass]="{
				'font-bold': isActive(),
				disabled: disabled(),
			}"
			[attr.aria-disabled]="disabled()"
			(click)="onItemClicked({ id: id(), text: text() })"
		>
			<p class="text-mainColor">
				<ng-content select="[textPrefix]"></ng-content>
				{{ text() }}
			</p>

			@if (!!secondaryText()) {
				<p class="text-mainColor">
					{{ secondaryText() }}
				</p>
			}

			<ng-content select="[extraElements]"></ng-content>
		</li>
	`,
	styles: [
		`
			li {
				position: relative;
			}

			li.disabled {
				opacity: 0.5;
				cursor: not-allowed;
				pointer-events: none;
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownItemComponent {
	readonly id = input(-1); // leave -1 if irrelevant
	readonly text = input('');
	readonly secondaryText = input(null);

	readonly isActive = input(false);
	readonly disabled = input(false);

	readonly itemClick = output<DropdownItem>();

	private readonly dropdownService = inject(DropdownService);

	onItemClicked(item: DropdownItem): void {
		if (this.disabled()) return;

		this.itemClick.emit(item);
		this.dropdownService.dispatchCloseDropdown();
	}
}
